<div class="container">
    <app-followed-folders-search-bar class="followed-folders-search-bar" [columns]="displayedColumnsDefinitions"></app-followed-folders-search-bar>
    <div class="right-container">
        <app-folders-list-counter></app-folders-list-counter>
        <div class="general-command-bar">
            <button
                mat-fab
                class="basic-button small"
                aria-label="Rafrichir la liste"
                tabindex="6"
                matTooltip="Rafrichir la liste"
                matTooltipPosition="below"
                (click)="onRefresh()">
                <fa-icon [icon]="faRotateRight"></fa-icon>
            </button>
        </div>
    </div>
</div>
<div #resultsContainer class="result-container" (scroll)="onScroll($event)">
    @if (loadedFoldersCount > 0) {
        <table
            mat-table
            class="result-table"
            [dataSource]="tableDataSource"
            matSort
            (matSortChange)="sortFolders($event)"
            [matSortActive]="currentSort.active"
            [matSortDirection]="currentSort.direction"
            multiTemplateDataRows>
            @for (column of displayedColumnsDefinitions; track column.propertyCode; let i = $index) {
                <ng-container [matColumnDef]="column.propertyCode">
                    <th mat-header-cell *matHeaderCellDef [style.min-width.%]="column.size" [style.max-width.%]="column.size" [style.width.%]="column.size">
                        <app-table-header-cell [column]="column" [disabledSort]="column.propertyCode === 'viewName'"></app-table-header-cell>
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let row"
                        [style.min-width.%]="column.size"
                        [style.max-width.%]="column.size"
                        [style.width.%]="column.size"
                        (contextmenu)="copyTextIntoClipboard($event)">
                        <app-table-cell class="resultTable-cell" [column]="column" [row]="row" [isFollowedFoldersList]="true"></app-table-cell>
                    </td>
                </ng-container>
            }
            <ng-container [matColumnDef]="actionColumnDefinition.propertyCode" stickyEnd>
                <th mat-header-cell *matHeaderCellDef [style.min-width.%]="5" [style.max-width.%]="5" [style.width.%]="5" class="action-header">
                    <div class="action-header-text">{{ actionColumnDefinition.header }}</div>
                </th>
                <td
                    mat-cell
                    *matCellDef="let row; let index = dataIndex"
                    class="action-column"
                    [style.min-width.%]="5"
                    [style.max-width.%]="5"
                    [style.width.%]="5"
                    class="action-cell">
                    <app-table-action-cell
                        [actionColumnDefinition]="actionColumnDefinition"
                        [row]="row"
                        [view]="viewsMap.get(row.viewId)"
                        [index]="index"
                        [isFollowedFolders]="true"
                        (contextualMenuOpen)="onContextualMenuOpen($event)"
                        (contextualMenuSelect)="onContextualMenuSelect($event)"></app-table-action-cell>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnCodes; sticky: true"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnCodes; let index = dataIndex"
                class="element-row"
                [class.selected]="isSelected(index)"
                (click)="onMouseClick($event, index)"
                (dblclick)="onMouseDoubleClick($event, index)"></tr>
        </table>
    }

    @if (loadedFoldersCount === 0) {
        <div class="no-folder-container mat-table">
            <p>Aucun dossier existant.</p>
        </div>
    }

    <ngx-spinner name="follow-folders-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
